import { useMutation } from '@hooks/reactQuery';

import { removeAssets } from '@api/assets';

import { handleErrorFromMessage } from '@utils/handleRequestError';

import { TGetAssetsDTO } from '@interfaces/assets/dto/assetsDTO';
import { IGroupOperationWithActionDTO } from '@interfaces/common/defaultDTO';
import { IResponseError } from '@interfaces/errors/apiErrors';

import { EMenuActionsTypes } from '@enums/common';

import { DELETE_ASSETS } from '@constants/queryKeys';

export const useMutateDeleteAssetsById = ({
		filters,
		onSettledCallbacks,
	}: {
		filters: TGetAssetsDTO;
		onSettledCallbacks?: Array<() => void>;
	}) => {
		const {
			mutate: handleDeleteAssets,
			isLoading: isLoadingDeleteAssets,
		} = useMutation<IGroupOperationWithActionDTO>({
			mutationKey: [DELETE_ASSETS, filters],
			mutationFn: ({ ids, actionType }: IGroupOperationWithActionDTO) => {
				return removeAssets({
					filter: (actionType === EMenuActionsTypes.allFiltered) && filters
						? filters
						: null,
					ids,
					isAll: actionType === EMenuActionsTypes.all || actionType === EMenuActionsTypes.allFiltered,
				});
			},
			onSuccess: () => {
				if (onSettledCallbacks?.length) {
					onSettledCallbacks.forEach((callback) => callback());
				}
			},
			onError: (err: IResponseError) => {
				if (onSettledCallbacks?.length) {
					onSettledCallbacks.forEach((callback) => callback());
				}

				handleErrorFromMessage(err);
			},
		});

		return { handleDeleteAssets, isDeletingAssets: isLoadingDeleteAssets };
	}
;
